<ul class="flex flex-col gap-2 mt-2 overflow-y-auto max-h-[70vh]">
  @for (order of orders(); track order.id) {
    <li
      class="soft-card rounded-sm border border-primary border-solid cursor-pointer hover:bg-hover"
      data-testid="select-kopfkomm-item"
      (click)="onSelect(order)"
    >
      <soft-picking-order [pickingOrder]="order" [small]="true" />
    </li>
  }
</ul>
